import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.e5i().y51() : headers;
  return DelegatedCall().c5k(_this__u8e3s4.z5h_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static c5k(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.e5i().y51() : responseHeaders;
        var $this = this.d5k(client);
        $this.b5i_1 = new (DelegatedRequest())($this, originCall.e5k());
        $this.c5i_1 = new (DelegatedResponse())($this, originCall.e5i(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.j5k_1 = origin;
        this.k5k_1 = call;
      }
      l5k() {
        return this.k5k_1;
      }
      dw() {
        return this.j5k_1.dw();
      }
      m5k() {
        return this.j5k_1.m5k();
      }
      n5k() {
        return this.j5k_1.n5k();
      }
      f5k() {
        return this.j5k_1.f5k();
      }
      r2o() {
        return this.j5k_1.r2o();
      }
      y51() {
        return this.j5k_1.y51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.y51() : headers;
        super();
        this.o5k_1 = call;
        this.p5k_1 = origin;
        this.q5k_1 = content;
        this.r5k_1 = headers;
        this.s5k_1 = this.p5k_1.dw();
      }
      l5k() {
        return this.o5k_1;
      }
      y51() {
        return this.r5k_1;
      }
      t5k() {
        return this.q5k_1(this.p5k_1);
      }
      dw() {
        return this.s5k_1;
      }
      u5k() {
        return this.p5k_1.u5k();
      }
      v5k() {
        return this.p5k_1.v5k();
      }
      w5k() {
        return this.p5k_1.w5k();
      }
      x5k() {
        return this.p5k_1.x5k();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
